"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStep = exports.RenderPage = void 0;
var RenderPage;
(function (RenderPage) {
    RenderPage[RenderPage["Left"] = 0] = "Left";
    RenderPage[RenderPage["Center"] = 1] = "Center";
    RenderPage[RenderPage["Right"] = 2] = "Right";
    RenderPage[RenderPage["NoTrans"] = 3] = "NoTrans";
})(RenderPage = exports.RenderPage || (exports.RenderPage = {}));
exports.getStep = function (col, row) {
    return Math.max(col, 4) * Math.max(row, 1);
};
